var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "accordionPlus",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "circle",
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EDE9F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_145_7188",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_145_7188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 21H13V19H19V13H21V19H27V21H21V27H19V21Z",
    fill: "#49247D",
    className: "innerText"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionPlus);
export default __webpack_public_path__ + "static/media/accordionPlus.b96375f6589b949162e1efb2c66428cb.svg";
export { ForwardRef as ReactComponent };